import { OrganizationCompactEntity, OrganizationEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const OrganizationResource = authResource({
    path: '/organizations/:id',
    searchParams: {},
    schema: OrganizationEntity
})
    .extend('getList', {
    schema: paginatedSchema(OrganizationCompactEntity)
})
    .extend('update', {
    schema: undefined
});
